export default __webpack_public_path__ + "static/media/Mark-6-HUD-11.93e64da4.jpg";